/**
 * What the "Who this goes to" panel on Attorney Questions shows. Pure, so it is unit-tested.
 *
 * The panel is never empty. Every question has at least one recipient (an attorney, or the
 * Coverage Questions mailbox), so an empty preview means something failed, and the agent is told
 * so instead of seeing a blank box. (External audit eb927415, P3.)
 */
export const RECIPIENTS_LOAD_ERROR = "Couldn't load recipients — try again.";

export type RecipientPanelState =
  | { kind: "loading" }
  | { kind: "error"; message: string }
  | { kind: "rows" };

export function recipientPanelState(
  isLoading: boolean,
  error: unknown,
  rowCount: number,
): RecipientPanelState {
  if (isLoading) {
    return { kind: "loading" };
  }
  if (error || rowCount === 0) {
    return { kind: "error", message: RECIPIENTS_LOAD_ERROR };
  }
  return { kind: "rows" };
}
